import createVueComponent from '../createVueComponent';

const Contrast = createVueComponent('ContrastIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M12 18a6 6 0 0 0 0-12v12z', key: 'j4l70d' }],
]);

export default Contrast;
